"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowAction = void 0;
var WorkflowAction;
(function (WorkflowAction) {
    WorkflowAction["START"] = "START";
    WorkflowAction["END"] = "END";
    WorkflowAction["APPROVAL"] = "APPROVAL";
    WorkflowAction["TASK"] = "TASK";
    WorkflowAction["NOTIFICATION"] = "NOTIFICATION";
})(WorkflowAction || (exports.WorkflowAction = WorkflowAction = {}));
